import { useState, useCallback, useContext } from "react";
import AuthContext from "../store/auth-context";
import { API_NEW_URL } from './../constants/constants';
import { maybeRefreshDomainConfig } from '../utils/domainConfig';

const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const BASEURL = API_NEW_URL;
  const clientID = process.env.REACT_APP_CLIENTID;
  const authCtx = useContext(AuthContext);
  const sendRequest = useCallback(async (requestConfig, applyData) => {
    setIsLoading(true);
    setError(null);
    requestConfig.headers.clientappid = clientID;
    try {
      const response = await fetch(BASEURL + requestConfig.url, {
        method: requestConfig.method ? requestConfig.method : "GET",
        headers: requestConfig.headers,
        body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
      });

      // SA-change check: refetch tenant config if the backend's
      // `configurationmodifiedat` header is newer than the cached one.
      maybeRefreshDomainConfig(response.headers);

      if (!response.ok) {
        console.log(response);
        const data = await response.json();
        console.info(data);
        if (response.status == 401) {
          const error = new Error(data.data.Error);
          error.status = -1;
          throw error;
        } else  if (response.status == 422) {
          const error = new Error(data.data.Error);
          error.status = -11;
          throw error;
        } else {
          const error = new Error("Request failed!");
          error.status = -10;
          throw error;
        }
      }
      if (
        response.headers.get("STATUS") == -2 ||
        response.headers.get("STATUS") == -3 ||
        response.headers.get("STATUS") == -4
      ) {
        const error = new Error(response.headers.get("MESSAGE"));
        error.status = response.headers.get("STATUS");
        throw error;
      }
      if (response.headers.get("STATUS") == -5) {
        authCtx.clearData();
        const error = new Error(response.headers.get("MESSAGE")+ " Trying to connect again...");
        error.status = response.headers.get("STATUS");
        throw error;
      }
      const data = await response.json();

      applyData(data);
    } catch (err) {
      const errorVal = {
        errorStatus: err.status,
        message: err.message,
      };
      applyData(errorVal);
      setError(err.message || "Something went wrong!");
    }
    setIsLoading(false);
  }, []);

  return {
    isLoading,
    error,
    sendRequest,
  };
};

export default useHttp;
